import { render } from "./SimilarityProfileFormPage.vue?vue&type=template&id=17f065c2&ts=true"
import script from "./SimilarityProfileFormPage.vue?vue&type=script&lang=ts"
export * from "./SimilarityProfileFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__